import { useQuery } from '@apollo/client/react';
import RejectedIcon from "@mui/icons-material/Block";
import AcceptedIcon from "@mui/icons-material/Done";
import PendingIcon from "@mui/icons-material/MoreHoriz";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import useAuth from "context/AuthContext";
import { APPLICATIONS_QUERY } from "graphql-local/getUserRegistrations";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppDataContext } from "../../../context/index";

// Subcomponent
const StatusChip = (props) => {
  const { status, t } = props;
  if (status === 0)
    return (
      <Chip
        label={t("Pending")}
        icon={<PendingIcon style={{ color: "white" }} />}
        style={{ backgroundColor: "blue", color: "white" }}
      />
    );
  else if (status === 1)
    return (
      <Chip
        label={t("Accepted")}
        icon={<AcceptedIcon style={{ color: "white" }} />}
        style={{ backgroundColor: "green", color: "white" }}
      />
    );
  else if (status === 2)
    return (
      <Chip
        label={t("Rejected")}
        icon={<RejectedIcon style={{ color: "white" }} />}
        style={{ backgroundColor: "red", color: "white" }}
      />
    );
  else return "unknown";
};


const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-cell': {
    padding: theme.spacing(1),
  },
}));

// main component
const Applications = (props) => {
  const ctx = React.useContext(AppDataContext);
  const { getSportName } = ctx;
  const { t, i18n } = useTranslation();
  const { user } = useAuth()
  // TODO: find a better way to parse query before render
  const getSportNames = (data) => {
    if (!data || !data.sports || !Array.isArray(data.sports)) return "";

    const sportIds = data.sports;
    let resultString = "";

    sportIds.forEach((sportid) => {
      const sportName = getSportName(parseInt(sportid));
      if (sportName && sportName[i18n.language]) {
        resultString += sportName[i18n.language] + ", ";
      }
    });

    return resultString.length > 0
      ? resultString.substring(0, resultString.lastIndexOf(", "))
      : "";
  };
 const columns = [
    {
      field: 'siteid',
      headerName: t('sport club'),
      flex: 1
    },
    {
      field: 'created_at',
      headerName: t('Created at'),
      valueGetter: (params) => {
        if (!params?.row?.created_at) return '';
        return moment.unix(params.row.created_at).format('DD/MM/YYYY');
      },
      flex: 1
    },
    {
      field: 'sports',
      headerName: t('Sports'),
      valueGetter: (params) => {
        if (!params?.row?.data) return '';
        return getSportNames(params.row.data);
      },
      flex: 1.5
    },
    {
      field: 'comments',
      headerName: t('Comments'),
      flex: 2
    },
    {
      field: 'status',
      headerName: t('Status'),
      width: 150,
      renderCell: (params) => {
        if (!params?.row) return null;
        return <StatusChip t={t} status={params.row.status} />;
      }
    }
  ];


  const { loading, error, data } = useQuery(APPLICATIONS_QUERY, {
    variables: { id: user.id },
  });
  if (loading) return <div>{t("Fetching")}</div>;
  if (error) return <div>{error.message}</div>;

  return (
    <div style={{ maxWidth: "100%" }}>
      <Typography variant="h5" gutterBottom>
        {t("My signup applications")}
      </Typography>
      <Typography variant="subtitle2" style={{ marginBottom: "20px" }} color="textSecondary" gutterBottom>
        {t("Here you can view the status of your signup applications")}
      </Typography>

      <div style={{ height: 400, width: '100%' }}>
        <StyledDataGrid
          rows={data.userRegistrations}
          columns={columns}
          disableSelectionOnClick
          disableColumnMenu={false}
        />
      </div>
    </div>
  );
};

export default Applications;
